// extracted by mini-css-extract-plugin
module.exports = {"userBox":"UserBox_userBox__15DVf","userBoxButton":"UserBox_userBoxButton__MFvmM","userBoxList":"UserBox_userBoxList__3UBA1","userName":"UserBox_userName__12bZp"};